import { request } from '../utils/request';
import type {
  AccountHierarchyTreeResponse,
  UnassignedUserResponse,
  PossibleParentResponse,
  CreateNodeRequest,
  UpdateNodeRequest,
  GroupNodesRequest,
  HierarchyLevelsResponse,
  ManageObserversRequest,
  NodeObserver,
} from '../types/account-hierarchy.types';

export const createHierarchyNode = async (
  accountUuid: string,
  data: CreateNodeRequest,
): Promise<{ message: string }> => {
  return request(`/accounts/${accountUuid}/hierarchy`, {
    method: 'POST',
    body: data,
  });
};

export const updateHierarchyNode = async (
  accountUuid: string,
  nodeUuid: string,
  data: UpdateNodeRequest,
): Promise<{ message: string }> => {
  return request(`/accounts/${accountUuid}/hierarchy/${nodeUuid}`, {
    method: 'PUT',
    body: data,
  });
};

export const getAccountHierarchyTree = async (
  accountUuid: string,
): Promise<AccountHierarchyTreeResponse> => {
  return request<AccountHierarchyTreeResponse>(
    `/accounts/${accountUuid}/hierarchy`,
  );
};

export const getUnassignedUsers = async (
  accountUuid: string,
  role?: string,
): Promise<{ users: UnassignedUserResponse[] }> => {
  const queryParams = role ? `?role=${role}` : '';
  return request<{ users: UnassignedUserResponse[] }>(
    `/accounts/${accountUuid}/hierarchy/unassigned-users${queryParams}`,
  );
};

export const getPossibleParents = async (
  accountUuid: string,
  nodeUuid: string,
): Promise<{ possibleParents: PossibleParentResponse[] }> => {
  return request<{
    possibleParents: PossibleParentResponse[];
  }>(`/accounts/${accountUuid}/hierarchy/${nodeUuid}/possible-parents`);
};

export const deleteHierarchyNode = async (
  accountUuid: string,
  nodeUuid: string,
): Promise<{ message: string }> => {
  return request(`/accounts/${accountUuid}/hierarchy/${nodeUuid}`, {
    method: 'DELETE',
  });
};

export const groupHierarchyNodes = async (
  accountUuid: string,
  data: GroupNodesRequest,
): Promise<{ message: string }> => {
  return request(`/accounts/${accountUuid}/hierarchy/group`, {
    method: 'POST',
    body: data,
  });
};

export const getHierarchyLevels = async (
  accountUuid: string,
): Promise<HierarchyLevelsResponse> => {
  return request<HierarchyLevelsResponse>(
    `/accounts/${accountUuid}/hierarchy/levels`,
  );
};

export const getUnassignedStaffUsers = async (
  accountUuid: string,
): Promise<{ users: UnassignedUserResponse[] }> => {
  return request<{ users: UnassignedUserResponse[] }>(
    `/accounts/${accountUuid}/hierarchy/unassigned-staff-users`,
  );
};

export const manageNodeObservers = async (
  accountUuid: string,
  nodeUuid: string,
  data: ManageObserversRequest,
): Promise<{ message: string }> => {
  return request(`/accounts/${accountUuid}/hierarchy/${nodeUuid}/observers`, {
    method: 'PUT',
    body: data,
  });
};

export const getNodeObservers = async (
  accountUuid: string,
  nodeUuid: string,
): Promise<{ observers: NodeObserver[] }> => {
  return request<{ observers: NodeObserver[] }>(
    `/accounts/${accountUuid}/hierarchy/${nodeUuid}/observers`,
  );
};
